module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__form-checkbox",
    class: {
      error: _vm.vError
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.htmlValue
    }
  }), _c('label', {
    staticClass: "__form-checkbox__label",
    class: _vm.labelClasses,
    on: {
      "click": function($event) {
        _vm.change(!_vm.value);
        _vm.$emit('click')
      }
    }
  }, [_vm._t("default"), (_vm.$slots.special) ? _c('span', {
    staticClass: "__form-checkbox__special"
  }, [_vm._t("special")], 2) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2575c8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Checkbox.vue
// module id = 84b00598d7343490b419
// module chunks = 89